import React from "react";
import { TicketDetailPageContent, TicketDetailPageStateProvider } from ".";
import {
  InfraTicketDescriptionDialogContent,
  InfraTicketDescriptionDialogStateProvider,
} from "../dialog/infra-ticket-description-dialog";

export const TicketDetailPage = () => {
  return (
    <TicketDetailPageStateProvider>
      <InfraTicketDescriptionDialogStateProvider>
        <InfraTicketDescriptionDialogContent />
        <TicketDetailPageContent />
      </InfraTicketDescriptionDialogStateProvider>
    </TicketDetailPageStateProvider>
  );
};
